<template>
  <table class="table table-hover the-datatable" id="datatable">
    <thead>
      <tr v-if="isOrder">
        <th v-if="isPurchase === true">
          <input id="mainCheck" type="checkbox" @click="checkMainCheck()" />
        </th>
        <th>Order Detail</th>
        <th>Info & Date</th>
      </tr>

      <tr v-if="isStaff">
        <th>Staff Detail</th>
        <th>Info & Status</th>
      </tr>

      <tr v-if="isCustomer">
        <th>Customer Detail</th>
        <th>Credit</th>
      </tr>

      <tr v-if="isCustomerCredit">
        <th>Invoice Detail</th>
        <th>Action & Date</th>
      </tr>

      <tr v-if="isCoupon">
        <th>Coupon Detail</th>
        <th>Status & Dates</th>
      </tr>

      <tr v-if="isTransactionOrder">
        <th>Order Detail</th>
        <th>Customer & Date</th>
      </tr>

      <tr v-if="isTransactionCredit">
        <th>Staff & Customer</th>
        <th>Status & Date</th>
      </tr>

      <tr v-if="isExchange">
        <th>Rate Detail</th>
        <th>Date & Actions</th>
      </tr>
    </thead>
    <slot></slot>
  </table>
</template>

<script>
export default {
  props: [
    'isPurchase',
    'checkAll',
    'unCheckAll',
    'isStaff',
    'isCustomer',
    'isCustomerCredit',
    'isOrder',
    'isCoupon',
    'isTransactionOrder',
    'isTransactionCredit',
    'isExchange'
  ],
  methods: {
    checkMainCheck() {
      if ($('#mainCheck').is(':checked')) {
        this.checkAll()
      } else {
        this.unCheckAll()
      }
    }
  }
}
</script>

<style scoped>
th {
  font-weight: bold;
  color: #273246;
}

.fa-sort {
  color: #bbb;
  pointer-events: none;
}
.fa-sort-down,
.fa-sort-up {
  color: blue;
  pointer-events: none;
}

.editable-container {
  position: absolute;
  top: 100px;
  z-index: 9999;
}
</style>



// WEBPACK FOOTER //
// src/components/mobileDatatable.vue